export const SCREENS = {
    home: {},
}

export const TITLES_HEADER = [
    { title: 'Contact Us', navigation: 'contact' },
    { title: 'Subscribe', navigation: 'subscribe' },
]
